import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { ShipmentFiltersDatepickerRangeOutput, StatisticFilterModel } from '../models/shipment-filters.model';
import { ListViewMode } from '../../constants/list-view-mode.constant';
import { ShipmentEndpoint } from '../constants';
import { ExportType } from '../../../../constants/status.constant';
import { convertDateRangesToWallClockUTC } from '../../../../../common';

@Injectable({ providedIn: 'root' })
export class ShipmentExportService {
  private readonly url = `${API_URL}${ShipmentEndpoint.Shipment}${ShipmentEndpoint.Exports}`;
  constructor(private http: WrapperHttpService) {}

  startExportToFile(body: {
    reportName: string;
    reportType: ExportType;
    searchRequestView: {
      filter: Partial<ShipmentFiltersDatepickerRangeOutput>;
      statisticFilter: StatisticFilterModel;
      viewMode: ListViewMode;
    };
  }): Observable<void> {
    return this.http.withLoading().post<void>(this.url, {
      ...body,
      searchRequestView: {
        ...body.searchRequestView,
        filter: convertDateRangesToWallClockUTC(body.searchRequestView.filter),
      },
    });
  }
}
